export const storyLines: IStoryLines = {
  l2: {
    id: 'l2',
    speakerName: 'Narrator',
    text: 'Introducing the modelZ hovercraft',
    audioUrl: 'https://example.com/audio/glide.mp3',
    textPhonetics: 'ɡlaɪd ˈoʊvər lænd ænd ˈwɔːtər wɪð iz',
    timestamp: 1,
  },
  l3: {
    id: 'l3',
    speakerName: 'Narrator',
    text: 'Experience the thrill of the smooth seismic engine',
    audioUrl: 'https://example.com/audio/clean_energy.mp3',
    textPhonetics: 'ˈpaʊərd baɪ klin ˈɛnərʤi',
    timestamp: 3.5,
  },
  l4: {
    id: 'l4',
    speakerName: 'Narrator',
    text: 'Delivering unparalleled speed and agility',
    audioUrl: 'https://example.com/audio/design_controls.mp3',
    textPhonetics: 'slik dɪˈzaɪn. ɪnˈtuːɪtɪv kənˈtroʊlz',
    timestamp: 15,
  },
  l5: {
    id: 'l5',
    speakerName: 'Narrator',
    text: 'Unleashing the raw power of our state-of-the-art distributors',
    audioUrl: 'https://example.com/audio/journey.mp3',
    textPhonetics: 'ˈmɑːdl zɛd: təˈmɑːroʊ, təˈdeɪ',
    timestamp: 20,
  },
  l6: {
    id: 'l6',
    speakerName: 'Narrator',
    text: 'And taking our driving experience to another dimensions',
    audioUrl: 'https://example.com/audio/journey.mp3',
    textPhonetics: 'ˈmɑːdl zɛd: təˈmɑːroʊ, təˈdeɪ',
    timestamp: 20,
  },
};
